import React, { useState, useEffect } from 'react';

import Link from 'eventbrite_design_system/link/Link';
import Icon from 'eventbrite_design_system/icon/Icon';

import './StateMessage.scss';

export default function StateMessage({
    title,
    description,
    iconType,
    iconSize,
    primaryLink,
    primaryText,
}) {
    const [isInBrowser, setIsInBrowser] = useState(false);

    useEffect(() => setIsInBrowser(true), []);

    // Don't render this page on the server, wait until it's in browser
    return (
        isInBrowser && (
            <section className="feed-state-msg eds-l-pad-vert-6 eds-align--center-vertical">
                <Icon type={iconType} size={iconSize} />
                <header className="eds-text-bl eds-l-mar-top-6">
                    <h3>{title}</h3>
                </header>
                <p className="eds-text-bm eds-text--center eds-text-color--ui-600 eds-l-mar-top-1 eds-l-mar-bot-4">
                    {description}
                </p>
                {primaryLink && (
                    <Link to={primaryLink}>
                        <p className="eds-text-weight--heavy">{primaryText}</p>
                    </Link>
                )}
            </section>
        )
    );
}
